/**
 * Add default unit (px) to a value if it doesn't already have a unit
 *
 * @param {string} value - The value to ensure has units
 * @returns {string} Value with units
 */
export function ensureUnit( value: string ): string {
	if ( ! value ) return value;

	// If value is just a number, add px
	if ( /^\d+(\.\d+)?$/.test( value ) ) {
		return `${ value }px`;
	}

	// Return as-is if it already has units or is not a simple number
	return value;
}
